import { MemberGroupLayout } from '../../../components/MemberGroup';
import { usePageTitle } from '../../../hooks';

export function MemberGroups() {
  usePageTitle('memberGroup:title');
  return <MemberGroupLayout />;
}
